import { useState } from 'react';

import { Button, Menu } from 'antd';
import FooterSidebar from 'layout/PrivateLayout/FooterSidebar';
import { SidebarWrapper } from 'layout/PrivateLayout/styles';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAnglesLeft,
  faAnglesRight,
  // faHouse,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faArrowsRotate,
  faBoxesStacked,
  faBusinessTime,
  faGear,
  faLayerGroup,
  faRightLeft,
  faShuffle,
  faStore,
  faUserGroup,
} from '@fortawesome/pro-regular-svg-icons';
import { newCheckRole } from 'utils/tools';
import { useSelector } from '@redux';
import { DynamicObjectType } from 'core/types/common';

const items: any = [
  // {
  //   key: '/',
  //   icon: (
  //     <div className="menu-icon-wrap">
  //       <FontAwesomeIcon
  //         icon={faHouse}
  //         className="text-gray-second-color text-sm"
  //       />
  //     </div>
  //   ),
  //   label: 'sidebar.dashboard',
  //   url: '/',
  // },
  {
    key: ['/'],
    icon: (
      <div className="menu-icon-wrap">
        <FontAwesomeIcon
          icon={faLayerGroup}
          className="text-gray-second-color text-sm"
        />
      </div>
    ),
    label: 'sidebar.orderManagement',
    url: '/order-management',
    endpoint: '/orders',
  },
  {
    key: '/orders-return',
    icon: (
      <div className="menu-icon-wrap">
        <FontAwesomeIcon
          icon={faRightLeft}
          className="text-gray-second-color text-sm"
        />
      </div>
    ),
    label: 'sidebar.returnManagement',
    url: '/orders-return',
    endpoint: '/return-orders',
  },
  {
    key: '/transfer-orders',
    icon: (
      <div className="menu-icon-wrap">
        <FontAwesomeIcon
          icon={faShuffle}
          className="text-gray-second-color text-sm"
        />
      </div>
    ),
    label: 'sidebar.transferOrders',
    url: '/transfer-orders',
    endpoint: '/transfer-orders',
  },
  {
    key: '/orders-exchange',
    icon: (
      <div className="menu-icon-wrap">
        <FontAwesomeIcon
          icon={faArrowsRotate}
          className="text-gray-second-color text-sm"
        />
      </div>
    ),
    label: 'sidebar.ordersExchange',
    url: '/orders-exchange',
    endpoint: '/orders-exchange',
  },
  {
    key: '/orders-keep-and-try',
    icon: (
      <div className="menu-icon-wrap">
        <FontAwesomeIcon
          icon={faStore}
          className="text-gray-second-color text-sm"
        />
      </div>
    ),
    label: 'sidebar.ordersTabTryBuy',
    url: '/orders-keep-and-try',
  },
  {
    key: '/batch-management',
    icon: (
      <div className="menu-icon-wrap">
        <FontAwesomeIcon
          icon={faBoxesStacked}
          className="text-gray-second-color text-sm"
        />
      </div>
    ),
    label: 'sidebar.batchManagement',
    url: '/batch-management',
    endpoint: '/order-batches',
  },
  {
    key: '/inventory',
    icon: (
      <div className="menu-icon-wrap">
        <FontAwesomeIcon
          icon={faBusinessTime}
          className="text-gray-second-color text-sm"
        />
      </div>
    ),
    label: 'sidebar.stockManagement',
    url: '/inventory',
    endpoint: '/inventories',
  },
  {
    key: '/users',
    icon: (
      <div className="menu-icon-wrap">
        <FontAwesomeIcon
          icon={faUserGroup}
          className="text-gray-second-color text-sm"
        />
      </div>
    ),
    label: 'sidebar.userManagement',
    url: '/users',
    endpoint: '/users',
  },
  {
    key: '/settings',
    icon: (
      <div className="menu-icon-wrap">
        <FontAwesomeIcon
          icon={faGear}
          className="text-gray-second-color text-sm"
        />
      </div>
    ),
    label: 'sidebar.settings',
    url: '/settings',
    byPass: true,
  },
];

const getCurrentTab = (str, key) => {
  const paths = str && str.split('/');
  return paths && paths[key];
};

export default function Sidebar() {
  const { t } = useTranslation();
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const user = useSelector<DynamicObjectType>((state) => state.auth.data);

  // const [selected, setSelected] = useState(location.pathname);
  const url =
    getCurrentTab(location.pathname, 1) === 'order-management'
      ? ''
      : getCurrentTab(location.pathname, 1);

  const onChange = (e) => {
    // setSelected(e.key);
    navigate(e.key);
  };

  return (
    <SidebarWrapper
      width={260}
      trigger={null}
      collapsible
      theme="light"
      collapsed={collapsed}
      collapsedWidth={67}
    >
      <div className="logo-vertical">
        <Link to="/">
          <img
            height="27px"
            src={
              collapsed
                ? '/images/short-lighto-logo.png'
                : '/images/full-lighto-logo.png'
            }
          />
        </Link>
        <Button
          shape="circle"
          icon={
            collapsed ? (
              <FontAwesomeIcon
                icon={faAnglesRight}
                className="collapsed-icon"
              />
            ) : (
              <FontAwesomeIcon icon={faAnglesLeft} className="collapsed-icon" />
            )
          }
          onClick={() => setCollapsed(!collapsed)}
          className="btn-collapsed"
          id="btn-collapse"
        />
      </div>
      <div className="sidebar-menu">
        <Menu
          mode="vertical"
          selectedKeys={[`/${url}` || '/']}
          defaultSelectedKeys={[`/${url}` || '/']}
          onClick={onChange}
          items={items
            ?.filter((item: DynamicObjectType) =>
              item?.endpoint
                ? newCheckRole(
                    item?.endpoint,
                    'GET',
                    user?.roles,
                    user?.isSuperUser || item?.byPass,
                  )
                : true,
            )
            ?.filter((item) => !item?.isHidden)
            ?.map((e) => ({
              ...e,
              label: t(e.label),
              children: e?.children
                ?.filter((item) =>
                  item?.endpoint
                    ? newCheckRole(
                        item?.endpoint,
                        'GET',
                        user?.roles,
                        user?.isSuperUser || item?.byPass,
                      )
                    : true,
                )
                ?.filter((item) => !item?.isHidden)
                ?.map((i) => ({
                  ...i,
                  label: t(i.label),
                })),
            }))}
        />
      </div>
      <FooterSidebar collapsed={collapsed} />
    </SidebarWrapper>
  );
}
